<div class="width-100 grid grid-gap-10 align-c pointer "
  style="grid-template-columns: 30px  calc(100% - 40px);height: 52px;">
  <span *ngIf="!option?.nearby_ports || (!!option?.nearby_ports && !option?.nearby_ports.length)"
    class="material-symbols-outlined ">{{option?.location_type=="zipcode"?'home_pin':(option?.location_type && (option?.location_type).toLowerCase()=='ramp/icd'?'bus_railway':'directions_boat')}}</span>
  <img src="https://api.myairliftusa.com/uploads/nearby_icon_png_2_2024-12-23_14:45:12.png" class="icon-25"
    *ngIf="!!option?.nearby_ports && !!option?.nearby_ports.length">
  <div class="flex flex-d-c width-100">
    <div class="flex aling-c justify-space-between">
      <div class="overflow-e f-w-500 head-c font-12 width-100">{{option?.location_name}} <span
          *ngIf="!!option?.location_code">({{option?.location_code}})</span></div>
      <div class="flex align-c justify-r mar-l-10" *ngIf="!option?.nearby_ports">
        <div
          class="loc-chip  {{option?.location_type=='zipcode'?'loc-zip':(option?.location_type && (option?.location_type).toLowerCase()=='ramp/icd'?'loc-ramp':'')}}">
          {{(option?.location_type?option?.location_type:'PORT') | uppercase}}</div>
      </div>

    </div>
    <div class="overflow-e sub-c font-10" style="line-height: 12px;">
      <span *ngIf="!option?.nearby_ports || (!!option?.nearby_ports && !option?.nearby_ports.length)">
        <span *ngIf="!!option?.location_code">{{option?.location_code}} -
        </span>{{!!option?.country_code?option?.country_code:option?.city}}
      </span>
      <span *ngIf="!!option?.nearby_ports && !!option?.nearby_ports.length">
        <span *ngIf="!!option?.location_code">Ports near to {{option?.location_name}}</span>
      </span>
    </div>
  </div>
</div>


<!-- bus_railway  ramp-->
<!-- home_pin zipcode -->
<!-- directions_boat port -->
